// extracted by mini-css-extract-plugin
export var addButton = "_oe-0";
export var border = "_oe-8";
export var check = "_oe-h";
export var danger = "_oe-6";
export var dropdownContainer = "_oe-1";
export var editModalBody = "_oe-j";
export var footerContainer = "_oe-i";
export var fullWidth = "_oe-a";
export var hide = "_oe-9";
export var icon = "_oe-3";
export var input = "_oe-7";
export var inputFlex = "_oe-b";
export var inputWrapper = "_oe-c";
export var manualFocus = "_oe-5";
export var optionButton = "_oe-4";
export var pillWrapper = "_oe-e";
export var pointer = "_oe-2";
export var showOverflow = "_oe-f";
export var tagsFlex = "_oe-d";
export var xButton = "_oe-g";